<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="container" id="workflowDetailContainer">
  <mat-drawer-container [hasBackdrop]="false">
    <mat-drawer-content class="drawer-container">
      <oneapp-header
        *ngIf="workflow"
        [title]="workflow.name"
        (buttonClick)="onActionButtonClick($event)"
        [customButtonConfig]="customButtonConfig"
        [customButtonConfig2]="customButtonConfig2"
        [actionsMenuConfig]="actionsMenuConfig"
      ></oneapp-header>

      <div class="tab-group-container">
        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          id="tabGroupContainer"
          (selectedTabChange)="onTabChange($event)"
          [(selectedIndex)]="selectedTabIndex"
        >
          <mat-tab
            class="tab-container"
            labelClass="workflow-details-tab-label"
            i18n-label="@@details"
            label="Details"
          >
            <div *ngIf="isTabLoaded(DETAILS_TAB)" fxLayout="column">
              <!-- loading spinner -->
              <div
                *ngIf="loadingWorkflow"
                fxFill
                fxLayoutAlign="center center"
                class="loading-spinner-container"
              >
                <fa-icon
                  class="icon loading_spinner"
                  [icon]="faSpinnerThird"
                  aria-label="user settings button"
                ></fa-icon>
              </div>
              <div class="detail_data_container" *ngIf="!loadingWorkflow" fxLayout="column">
                <!-- general data -->
                <div class="section" fxLayout="column">
                  <!-- Description -->
                  <app-workflow-property
                    label="Description"
                    [text]="workflow.description ?? '-'"
                    i18n-label="@@description"
                  ></app-workflow-property>
                  <!-- Published -->
                  <app-workflow-property
                    label="Published"
                    [date]="workflow.createdAt"
                    [version]="workflow.version"
                    i18n-label="published label@@published"
                  >
                  </app-workflow-property>

                  <!-- Geo-Tracking -->
                  <app-workflow-property
                    label="Geo-Tracking"
                    [text]="geoCodingEnabled"
                    i18n-label="geo-tracking label@@geoTracking"
                  >
                  </app-workflow-property>

                  <!-- Save Time Stamps -->
                  <app-workflow-property
                    label="Save Time Stamps"
                    [text]="saveTimeStamps"
                    i18n-label="save time stamps label@@saveTimeStamps"
                  >
                  </app-workflow-property>
                </div>

                <div class="section">
                  <div fxLayout="column" fxLayoutGap="16px">
                    <div fxLayout="column" fxLayoutGap="2px">
                      <span class="detail_header" i18n="Analytics@@analytics">Analytics</span>
                      <span
                        i18n="
                          Filter tasks by date of creation and due date to plan your
                          workflows.@@filterTasksByDate"
                        >Filter tasks by date of creation and due date to plan your workflows.</span
                      >
                    </div>
                    <app-workflow-filter-toolbar
                      [executedByText]="EXECUTED_BY_TEXT"
                      [selectEmployeesPlaceholder]="SELECT_EMPLOYEES_PLACEHOLDER"
                      [availableEmployees]="availableEmployees"
                      [selectedEmployeeIds]="selectedEmployeeIds"
                      [dateFilterValue]="currentDateFilter"
                      (employeeSelectionChange)="onEmployeeSelectionChange($event)"
                      (dateFilterChange)="onDateFilterChange($event)"
                    ></app-workflow-filter-toolbar>
                  </div>
                  <div class="analytics-container">
                    <div class="task-execution-header">
                      <strong i18n="Task execution header@@taskExecution" class="text-uppercase"
                        >task execution</strong
                      >
                    </div>
                    <div class="gantt-container">
                      <!-- Loading state -->
                      <div *ngIf="isLoadingAnalytics" class="analytics-loading">
                        <fa-icon [icon]="faSpinnerThird" animation="spin"></fa-icon>
                        <span i18n="Loading analytics message@@loadingAnalytics"
                          >Loading analytics...</span
                        >
                      </div>

                      <!-- Error state (only for published workflows) -->
                      <div
                        *ngIf="analyticsError && !isLoadingAnalytics && currentPublishedWorkflowId"
                        class="analytics-error"
                      >
                        <fa-icon [icon]="faCircleExclamation"></fa-icon>
                        {{ analyticsError }}
                      </div>

                      <!-- Gantt chart with analytics data (only when data is available) -->
                      <app-gantt-chart
                        *ngIf="ganttData && !isLoadingAnalytics && (ganttData?.total || 0) > 0"
                        [data]="ganttData"
                        height="10px"
                        [showTooltips]="true"
                        (segmentClick)="onGanttSegmentClick($event)"
                      >
                      </app-gantt-chart>
                    </div>
                    <div class="statistics-grid">
                      <div>
                        <!-- Total -->
                        <div
                          class="statistic-item total statistic-row with-margin"
                          [class.selected]="
                            selectedStatistic === 'total' && (ganttData?.total || 0) > 0
                          "
                          [class.disabled]="(ganttData?.total || 0) === 0"
                          (click)="(ganttData?.total || 0) > 0 ? onStatisticClick('total') : null"
                        >
                          <div class="statistic-content">
                            <strong i18n="@@total">Total</strong>
                          </div>
                          <strong
                            ><app-animated-counter
                              [value]="ganttData?.total || 0"
                              [delay]="100"
                            ></app-animated-counter
                          ></strong>
                        </div>
                        <!-- Finished -->
                        <div
                          class="statistic-item finished statistic-row with-margin"
                          [class.selected]="
                            selectedStatistic === 'finished' && (ganttData?.finished || 0) > 0
                          "
                          [class.disabled]="(ganttData?.finished || 0) === 0"
                          (click)="
                            (ganttData?.finished || 0) > 0 ? onStatisticClick('finished') : null
                          "
                        >
                          <div class="statistic-content">
                            <fa-icon class="icon finished" [icon]="faCircleCheck"></fa-icon>
                            <span i18n="@@ganttSegmentFinished">Finished</span>
                          </div>
                          <strong
                            ><app-animated-counter
                              [value]="ganttData?.finished || 0"
                              [delay]="200"
                            ></app-animated-counter
                          ></strong>
                        </div>
                        <!-- In Progress -->
                        <div
                          class="statistic-item in-progress statistic-row"
                          [class.selected]="
                            selectedStatistic === 'inProgress' && (ganttData?.inProgress || 0) > 0
                          "
                          [class.disabled]="(ganttData?.inProgress || 0) === 0"
                          (click)="
                            (ganttData?.inProgress || 0) > 0 ? onStatisticClick('inProgress') : null
                          "
                        >
                          <div class="statistic-content">
                            <fa-icon class="icon in-progress" [icon]="faCircle"></fa-icon>
                            <span i18n="In progress task chip@@inProgressTaskChip">In progress</span>
                          </div>
                          <strong
                            ><app-animated-counter
                              [value]="ganttData?.inProgress || 0"
                              [delay]="300"
                            ></app-animated-counter
                          ></strong>
                        </div>
                      </div>
                      <div>
                        <!-- Open -->
                        <div
                          class="statistic-item open statistic-row with-margin"
                          [class.selected]="
                            selectedStatistic === 'open' && (ganttData?.open || 0) > 0
                          "
                          [class.disabled]="(ganttData?.open || 0) === 0"
                          (click)="(ganttData?.open || 0) > 0 ? onStatisticClick('open') : null"
                        >
                          <div class="statistic-content">
                            <fa-icon class="icon open" [icon]="faCircle"></fa-icon>
                            <span i18n="@@openTaskChip">Open</span>
                          </div>
                          <strong
                            ><app-animated-counter
                              [value]="ganttData?.open || 0"
                              [delay]="400"
                            ></app-animated-counter
                          ></strong>
                        </div>
                        <!-- Overdue -->
                        <div
                          class="statistic-item overdue statistic-row with-margin"
                          [class.selected]="
                            selectedStatistic === 'overdue' && (ganttData?.overdue || 0) > 0
                          "
                          [class.disabled]="(ganttData?.overdue || 0) === 0"
                          (click)="
                            (ganttData?.overdue || 0) > 0 ? onStatisticClick('overdue') : null
                          "
                        >
                          <div class="statistic-content">
                            <fa-icon class="icon overdue" [icon]="faCircleExclamation"></fa-icon>
                            <span i18n="@@overdue">Overdue</span>
                          </div>
                          <strong
                            ><app-animated-counter
                              [value]="ganttData?.overdue || 0"
                              [delay]="500"
                            ></app-animated-counter
                          ></strong>
                        </div>
                        <!-- Scheduled tasks -->
                        <div
                          class="statistic-item scheduled statistic-row"
                          [class.selected]="
                            selectedStatistic === 'scheduled' && (ganttData?.scheduled || 0) > 0
                          "
                          [class.disabled]="(ganttData?.scheduled || 0) === 0"
                          (click)="
                            (ganttData?.scheduled || 0) > 0 ? onStatisticClick('scheduled') : null
                          "
                        >
                          <div class="statistic-content">
                            <fa-icon class="icon scheduled" [icon]="faCircleDashed"></fa-icon>
                            <span i18n="@@scheduledTasks">Scheduled tasks</span>
                          </div>
                          <strong
                            ><app-animated-counter
                              [value]="ganttData?.scheduled || 0"
                              [delay]="600"
                            ></app-animated-counter
                          ></strong>
                        </div>
                      </div>
                    </div>
                    <div class="statistics-divider"></div>
                    <div class="statistics-grid">
                      <div>
                        <!-- Tasks with incidents -->
                        <div
                          class="statistic-item with-incidents statistic-row"
                          [class.selected]="
                            selectedStatistic === 'withIncidents' &&
                            (ganttData?.withIncidents || 0) > 0
                          "
                          [class.disabled]="(ganttData?.withIncidents || 0) === 0"
                          (click)="
                            (ganttData?.withIncidents || 0) > 0
                              ? onStatisticClick('withIncidents')
                              : null
                          "
                        >
                          <div class="statistic-content">
                            <fa-icon
                              class="icon with-incidents"
                              [icon]="faDiamondExclamation"
                            ></fa-icon>
                            <span i18n="@@tasksWithIncidents">Tasks with incidents</span>
                          </div>
                          <strong
                            ><app-animated-counter
                              [value]="ganttData?.withIncidents || 0"
                              [delay]="700"
                            ></app-animated-counter
                          ></strong>
                        </div>
                      </div>
                      <div>
                        <!-- Empty right column -->
                      </div>
                    </div>
                  </div>
                </div>

                <div class="section">
                  <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="space-between center">
                    <div fxLayout="column" fxLayoutGap="4px">
                      <span class="section_header" i18n="@@sideSubMenuTasks">Tasks</span>
                      <span i18n="@@taskDateFilterDescription"
                        >Filter tasks by date range to plan your workflows.</span
                      >
                    </div>
                    <div class="expand"></div>
                  </div>

                  <div class="task-table">
                    <epg-table
                      *ngIf="taskTableModels.length > 0; else noTasksTemplate"
                      [columns]="taskColumns"
                      [data]="taskTableModels"
                      [selectableRows]="true"
                      [paginator]="true"
                      [totalRecords]="taskTableTotalCount"
                      [rowsPerPage]="10"
                      [serverSide]="true"
                      [loading]="loadingTasks"
                      [templates]="{
                        recurring: recurringIconTemplate,
                        scheduled_at: dateTemplate,
                        startedAt: dateTemplate,
                        endedAt: dateTemplate,
                        status: statusTemplate,
                        assignedTo: assignedToTemplate,
                        time_tracking: timetrackingTemplate,
                        incidents: incidentsTemplate
                      }"
                      (pageEvent)="onTaskPageEvent($event)"
                      (rowSelectionChange)="onTaskRowClick($event)"
                      #taskTable
                    ></epg-table>

                    <!-- Conditional empty state messages -->
                    <ng-template #noTasksTemplate>
                      <div
                        *ngIf="loadingTasks || totalTasksForWorkflow === null"
                        fxLayoutAlign="center center"
                        class="loading-spinner-container"
                      >
                        <fa-icon
                          class="icon loading_spinner"
                          [icon]="faSpinnerThird"
                          aria-label="loading"
                        ></fa-icon>
                      </div>

                      <ng-container *ngIf="!loadingTasks && totalTasksForWorkflow !== null">
                        <span
                          *ngIf="totalTasksForWorkflow === 0; else noTasksInRangeLabel"
                          class="no-data-text text-bold"
                          i18n="@@noDataAvailable"
                          >No data available.</span
                        >

                        <ng-template #noTasksInRangeLabel>
                          <span class="no-data-text text-bold" i18n="@@noTasksAvailable"
                            >No tasks in selected time range.</span
                          >
                        </ng-template>
                      </ng-container>
                    </ng-template>
                  </div>
                </div>

                <div class="section">
                  <div>
                    <span class="section_header" i18n="@@scheduling">Scheduling</span><a></a>
                    <span class="area_description" i18n="@@schedulingAreaDescription"
                      >Tasks will be created based on these configurations as a one-time task or
                      recurring task.</span
                    >
                  </div>
                  <div class="task-table">
                    <epg-table
                      *ngIf="currentScheduledTasks.length > 0; else noScheduledLabel"
                      [columns]="scheduledTaskColumns"
                      [data]="currentScheduledTasks"
                      [selectableRows]="false"
                      [paginator]="true"
                      [rowsPerPage]="10"
                      [templates]="{
                        assignedTo: assignedToTemplate,
                        recurring: recurringTextTemplate,
                        scheduledAt: startingFromTemplate
                      }"
                      #scheduledTaskTable
                    >
                    </epg-table>
                  </div>
                </div>

                <ng-template let-data="data" let-rowData="rowData" #recurringTextTemplate>
                  <div *ngIf="data">
                    {{
                      getRecurringConfigFromService(
                        data,
                        RecurringConfig.standalone,
                        rowData.scheduledAt
                      )
                    }}
                  </div>
                  <div *ngIf="!data">
                    <span i18n="Never@@never">Never</span>
                  </div>
                </ng-template>
                <ng-template let-data="data" let-rowData="rowData" #startingFromTemplate>
                  <div *ngIf="rowData.recurring">
                    <span i18n="@@startingFrom">Starting from</span>&nbsp;
                    <span>{{ formatShortDateAndTime(data) }}</span>
                  </div>
                  <div *ngIf="!rowData.recurring">
                    <span i18n="Scheduled for@@scheduledFor">Scheduled for</span>&nbsp;
                    <span>{{ formatShortDate(rowData.scheduledAt) }}</span>
                  </div>
                </ng-template>
                <ng-template let-data="data" let-rowData="rowData" #assignedToTemplate>
                  <span>{{ getAssignedTo(data, rowData) }}</span>
                </ng-template>
                <ng-template let-data="data" #statusTemplate>
                  <div>
                    <mat-chip-set
                      [ngClass]="{
                        'in-progress-chip': data === TaskStatus.IN_PROGRESS,
                        'finished-chip': data === TaskStatus.CLOSED
                      }"
                    >
                      <mat-chip *ngIf="data === TaskStatus.NEW"
                        ><span i18n="Open task chip@@openTaskChip">Open</span>
                        &nbsp;
                        <fa-icon class="icon" [icon]="faStar"></fa-icon
                      ></mat-chip>
                      <mat-chip *ngIf="data === TaskStatus.IN_PROGRESS"
                        ><span i18n="In progress task chip@@inProgressTaskChip">In progress</span>
                        &nbsp; <fa-icon class="icon" [icon]="faArrowRight"></fa-icon
                      ></mat-chip>
                      <mat-chip *ngIf="data === TaskStatus.CLOSED"
                        ><span i18n="Finished task chip@@finishedTaskChip">Finished</span>
                        &nbsp;
                        <fa-icon class="icon" [icon]="faCheck"></fa-icon
                      ></mat-chip>
                    </mat-chip-set>
                  </div>
                </ng-template>
                <ng-template let-data="data" let-rowData="rowData" #recurringIconTemplate>
                  <fa-icon
                    *ngIf="data"
                    class="icon recurring"
                    [icon]="faArrowsRepeat"
                    [matTooltip]="
                      getRecurringConfigFromService(
                        rowData.recurring,
                        RecurringConfig.withRepeat,
                        rowData.scheduled_at
                      )
                    "
                  ></fa-icon>
                </ng-template>
                <ng-template let-data="data" #timetrackingTemplate>
                  <span>{{ getDuration(data) }}</span>
                </ng-template>
                <ng-template let-data="data" #incidentsTemplate>
                  <fa-icon
                    *ngIf="data?.length"
                    class="icon with-incidents"
                    [icon]="faDiamondExclamation"
                  ></fa-icon>
                </ng-template>
                <ng-template let-data="data" #dateTemplate>
                  <span *ngIf="data">{{ data | date: 'short' }}</span>
                  <span *ngIf="!data">-</span>
                </ng-template>
                <ng-template #noScheduledLabel>
                  <span class="no-data-text text-bold" i18n="@@noScheduledTasksAvailable"
                    >No scheduling created yet.</span
                  >
                </ng-template>
              </div>
            </div>
          </mat-tab>
          <mat-tab
            class="tab-container"
            [disabled]="!is_published"
            labelClass="workflow-details-tab-label"
            i18n-label="@@actions"
            label="Actions"
          >
            <oneapp-workflow-actions-management
              *ngIf="isTabLoaded(ACTIONS_TAB)"
              [workflow]="workflow"
              (unsavedChangesExistEvent)="isUnsavedChangesExist($event)"
            ></oneapp-workflow-actions-management
          ></mat-tab>
          <mat-tab
            class="tab-container"
            [disabled]="!is_published"
            labelClass="workflow-details-tab-label"
            bodyClass="gallery-tab-body"
            i18n-label="@@sideMenuGallery"
            label="Gallery"
          >
            <!-- Lazy load Gallery content only when tab is selected -->
            <div *ngIf="isTabLoaded(GALLERY_TAB)" class="section gallery-tab-content">
              <!-- Header and filters - always visible -->
              <div fxLayout="column" fxLayoutGap="16px">
                <div>
                  <span class="detail_header" i18n="Worflow images@@workflowImagesHeader"
                    >Workflow images</span
                  ><br />
                  <span i18n="Filter images by date range or incidents@@filterImages"
                    >Filter images by date range or incidents.</span
                  >
                </div>
                <app-workflow-filter-toolbar
                  [executedByText]="EXECUTED_BY_TEXT"
                  [selectEmployeesPlaceholder]="SELECT_EMPLOYEES_PLACEHOLDER"
                  [availableEmployees]="availableEmployees"
                  [selectedEmployeeIds]="selectedEmployeeIds"
                  [dateFilterValue]="currentDateFilter"
                  (employeeSelectionChange)="onEmployeeSelectionChange($event)"
                  (dateFilterChange)="onDateFilterChange($event)"
                ></app-workflow-filter-toolbar>
              </div>

              <!-- Always render the gallery component to detect if images are available -->
              <div class="gallery-scroll-container">
                <!-- Show empty state when no images are available -->
                <div *ngIf="galleryLoaded && !galleryHasImages" fxLayoutAlign="center center">
                  <span
                    class="no-data-text text-bold"
                    i18n="No images available message@@noImagesAvailable"
                    >No images available for the selected time range.</span
                  >
                </div>

                <oneapp-task-image-grid
                  class="gallery"
                  [enableLink]="false"
                  [filter]="galleryFilter"
                  (imagesLoaded)="onGalleryImagesLoaded($event)"
                ></oneapp-task-image-grid>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>

        <app-workflow-badge
          *ngIf="!loadingWorkflow"
          class="status-badge"
          [isDraft]="workflow.is_draft || false"
          [isPublished]="workflow.is_published || false"
        ></app-workflow-badge>
      </div>
    </mat-drawer-content>
    <mat-drawer class="slide-in" mode="over" position="end" #taskDrawer>
      <app-task-detail
        *ngIf="selectedTaskId"
        [enableLink]="false"
        [taskId]="selectedTaskId"
        [showDismissButton]="true"
        (onDismissCallback)="dismissSlideIn()"
      ></app-task-detail>
    </mat-drawer>
    <mat-drawer class="slide-in task-manager-drawer" mode="over" position="end" #taskManagerDrawer>
      <app-task-manager
        *ngIf="taskManagerDrawer.opened"
        #taskManagerComponent
        class="task-manager-drawer__content"
        [workflow]="workflow"
        [dismissSlideInButton]="true"
        (onDismissCallback)="closeTaskManager()"
      ></app-task-manager>
    </mat-drawer>
  </mat-drawer-container>
</div>

<ng-template #workflowDuplicationTemplate>
  <app-workflow-creation
    [title]="dialogTitle"
    (cancel)="closeWorkflowDialog()"
    [workflowToDuplicateId]="currentDesignerWorkflowId"
    [duplicatedWorkflowName]="duplicatedWorkflowName"
    [duplicatedWorkflowDescription]="workflow.description ?? ''"
  ></app-workflow-creation>
</ng-template>

<ng-template #workflowUnpublishTemplate>
  <div class="warn-text">
    <span i18n="Unpublish workflow details@@unpublishDetailsWarn"
      >All related data (tasks, images, dashboard entries) will be permanently deleted and cannot be
      restored.</span
    >
  </div>
</ng-template>
